import { createSelector } from "reselect";

import { getIntegrationBusinesses } from "selectors";

export const selectIntegrationBusinessesAggridData = createSelector(
  [getIntegrationBusinesses],
  Object.values,
);
